import errorHandle from '../../../utils/errorHandle';
import { getDateDetailsFun, getDetailsFun } from '../../../api/infoAPI';
import { dateAva } from '../../../api/bookingAPI';

export default async function fetchTripData(type, packId, setLoading, setPackData, setPackDates) {
    setLoading(true);
    try {
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const allData = await getDetailsFun(type, packId);
        setPackData(allData.data.packdata);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export async function fetchTripDate(data) {
    try {
        const res = await dateAva(data, 'gu');
        return res.data.data;
    } catch (error) {
        errorHandle(error);
        return null; // ✅ always return something
    }
}
